<template>
  <div
    v-if="categoryDescription"
    class="mt-[40px] flex h-auto flex-col bg-neutral-50 px-[160px] py-[40px] text-left mobile:p-md [&_a]:underline [&_h2]:mb-sm [&_h2]:mt-lg"
    v-html="categoryDescription"
  />
</template>

<script lang="ts" setup>
const route = useRoute();
const { result: category, load } = useCategory();

if (!category.value) {
  await load();
}

const categoryDescription = computed(() => {
  const colors = route.path.includes('c_') ? route.path.split('c_')?.[1]?.split('.') : [];
  return (
    colors.length === 1 ? null : (route.meta?.isSale && category.value?.saleMetadata ? category.value?.saleMetadata.description : category.value?.description)
  );
});
</script>
